<div class="wrapper wrapper-content" [style.visibility]="isLoaded() ? 'visible' : 'hidden'">
  <div class="container-fluid">
    <div class="row">
      <div class="col-12 col-sm-2 sticky-top bg-white text-center p-0">
        <div class="sticky-top">
          <ul class="sortable-list connectList agile-list d-inline-flex flex-wrap d-sm-block" id="inprogress">
            <ng-container *ngFor="let item of items" [ngTemplateOutlet]="itemButton"
              [ngTemplateOutletContext]="{item: item}"></ng-container>
          </ul>
        </div>
      </div>
      <div class="col-12 col-sm-10 p-0">
        <div #infoContainer></div>
      </div>
      <ng-template #itemButton let-item="item">
        <li (click)="loadComponent(item)"
          *ngIf="this.profileService.isOptionEnabled(item.id,this.dossier?.division?.documentClass?.identifier)"
          [ngClass]="isComponentSelected(item)  ? 'info-element'  : 'success-element'" class="text-nowrap"
          pTooltip="{{ item.name |translate}}" tooltipPosition="right" showDelay="50"
          tooltipStyleClass="dossierinfo col-3 font-weight-bolder text-info">
          <i aria-hidden="true" class="{{ item.iconClass }}"></i>
          <div class="d-none d-md-block">{{ item.short |translate}}</div>
        </li>
      </ng-template>
    </div>
  </div>
</div>